__turbopack_context__.v({
  "sponsorship_explanation": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_explanation",
  "sponsorship_explanation__link": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_explanation__link",
  "sponsorship_explanation__text": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_explanation__text",
  "sponsorship_mobile_explanation": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_mobile_explanation",
  "sponsorship_unit": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_unit",
  "sponsorship_unit__full_width": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_unit__full_width",
  "sponsorship_unit__in_flow": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_unit__in_flow",
  "sponsorship_unit__rendered": "SponsorshipUnit-module-scss-module__fSHMQW__sponsorship_unit__rendered",
});
